import { addListType } from './actionTypes';

const addList = (state = {}, list) => {
  const newState = { ...state };
  list.forEach((item) => {
    newState[item.id] = { ...item };
  });
  return newState;
};

export default contentTypeId => (state = {}, action) => {
  switch (action.type) {
    case addListType(contentTypeId):
      return addList(state, action.payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/factories/reducers.js